
/**
 * Set all the elements in a set to the same height and/or width.
 *
 * @class Equalizer
 * @requires utilities.dom
 * @requires utilities.object
 * @requires utilities.element.getdimensions
 */

define('libs/equalizer',['libs/utilities.element.getDimensions'],function() {

    'use strict';

    var _getDimensions = require('libs/utilities.element.getDimensions');

    var SETTINGS = {
        selector: '.equal',
        setHeight: true,
        setWidth: false,
        hiddenParent: null
    };

    /** @constructor */
    var Equalizer = function() {
        this.init.apply(this, arguments);
    };

    /**
     * Initialize the component.
     * @param {Element} element The base element for the component.
     * @param {Object} settings The settings for the component.
     * @memberof Equalizer
     */
    Equalizer.prototype.init = function(element, settings) {
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend({}, SETTINGS, settings || {});

        if (this.settings.hiddenParent) {
            this.showHiddenParent(this.settings.hiddenParent);
            this.equalize();
            this.hideHiddenParent();
        } else {
            this.equalize();
        }
    };

    /**
     * Display the hidden parent so we can measure the child's dimensions.
     * @param {String} selector The css selector for the parent.
     */
    Equalizer.prototype.showHiddenParent = function(selector) {
        var $parent = this.hiddenParent = this.$element.closest(selector);
        if ($parent.length && $parent.css('display') == 'none') {
            this.parentStyles = {
                position: parent.style.position,
                visibility: parent.style.visibility,
                display: parent.style.display
            };
            $parent.css({
                position: 'absolute',
                visibility: 'hidden',
                display: 'block'
            });
        }
    };

    /**
     * Set all the styles for the hidden parent back as they were.
     */
    Equalizer.prototype.hideHiddenParent = function() {
        var $parent = this.hiddenParent;
        if ($parent.length) {
            $parent.css({
                position: this.parentStyles.position || '',
                visibility: this.parentStyles.visibility || '',
                display: this.parentStyles.display || ''
            });
        }
    };

    /**
     * Equalize all elements in the collection.
     * @param {Boolean} naturalHeight Use the element's natural height (discard any inline height styles)
     */
    Equalizer.prototype.equalize = function(naturalHeight) {
        var items = $(this.settings.selector, this.element),
            height = 0,
            width = 0;

        // find the tallest element's height.
        for (var i = 0; i < items.length; i++) {
            var dimensions = _getDimensions(items[i], naturalHeight);

            if (this.settings.setHeight && !items[i].attributes['data-ignore-equalize']) {
                height = Math.max(height, dimensions.innerHeight);
            }
            if (this.settings.setWidth && !items[i].attributes['data-ignore-equalize']) {
                width = Math.max(width, dimensions.innerWidth);
            }
        }

        console.log('equalize', 'naturalHeight', naturalHeight, height);

        // Equalize the items.
        for (i = 0; i < items.length; i++) {
            // set the height.
            if (this.settings.setHeight) {
                var scale = items[i].attributes['data-scale'] || items[i].attributes['data-scale-height'];
                scale = scale ? parseFloat(scale.value) : 1;
                items[i].style.height = (scale * height) + 'px';
            }

            // set the width.
            if (this.settings.setWidth) {
                scale = items[i].attributes['data-scale'] || items[i].attributes['data-scale-width'];
                scale = scale ? parseFloat(scale.value) : 1;
                items[i].style.width = (scale * width) + 'px';
            }
        }
    };

    return Equalizer;
});

